import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-13e3385b")

_pushScopeId("data-v-13e3385b")
const _hoisted_1 = { class: "ui__checkDescrip_tit" }
const _hoisted_2 = { class: "ui__checkDescrip_txt" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["ui__checkDescrip", {'noBac': _ctx.state.reportMsg.RpCK()}]
  }, [
    (!_ctx.state.reportMsg.RpCK())
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["ui__checkDescrip_cont", {'nopadding': _ctx.state.nopadding, 'smallpadding': _ctx.state.smallpadding}]
        }, [
          _createVNode("p", _hoisted_1, [
            _createVNode("img", {
              src: _ctx.state.icon
            }, null, 8, ["src"]),
            _createTextVNode(_toDisplayString(_ctx.state.tit), 1)
          ]),
          _createVNode("p", _hoisted_2, _toDisplayString(_ctx.state.content), 1)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
})